import styled from 'styled-components';

export const ViewerOverlayContainer = styled.div`
  position: relative;
  flex: 1;
  min-width: 0;
  height: 100%;
`;

export const PatientHistoryContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: absolute;
  inset: 0;
  padding: 16px 24px;
  background: #12161fef;
  z-index: 100;
`;

export const PatientHistoryMessage = styled(PatientHistoryContainer)`
  align-items: center;
  justify-content: center;
  color: #f5f7fb;
  font-size: 1.25rem;
`;

export const PatientHistoryCloseButton = styled.div`
  position: absolute;
  top: 20px;
  right: 32px;
  width: 20px;
  height: 20px;
  color: white;
  cursor: pointer;
  z-index: 101;
`;

export const FieldLabel = styled.span`
  color: #aebbd0;
  font-size: 0.875rem;
  font-weight: 600;
  text-transform: uppercase;
`;

export const PatientSummary = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  padding: 12px 18px;
  border: 1px solid #3a4557;
  border-radius: 12px;
  background: #1e2530df;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.75);

  ${FieldLabel} {
    cursor: default;
  }
`;

export const PatientField = styled.div`
  display: flex;
  flex: 1 1 160px;
  flex-direction: column;
  gap: 4px;
`;

export const FieldValue = styled.span`
  color: #f5f7fb;
  font-size: 1.25rem;
  font-weight: 600;
  line-height: 1;
`;

export const StudyContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  border: 1px solid #3a4557;
  border-radius: 10px;
  background: #1e25307f;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.75);
  overflow-y: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const StudyList = styled.div`
  overflow-y: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const StudyHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  padding: 12px 18px;
  border-bottom: 1px solid #3a4557;
  background: #2731427f;

  ${PatientField} {
    cursor: default;
  }
`;

export const StudyRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  padding: 9px 18px;
  border-bottom: 1px solid #313b4b;
  transition: background 320ms ease, box-shadow 320ms ease;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    cursor: pointer;
    background: #2a35459f;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.42);
  }
`;

export const StudyField = styled(PatientField)`
  flex-basis: 180px;
  justify-content: center;
`;

export const StudyHeaderField = styled(StudyField)`
  color: #c0cce0;
  font-size: 0.875rem;
  font-weight: 600;
  text-transform: uppercase;
`;

export const StudyValue = styled(FieldValue)`
  font-size: 1.125rem;
  line-height: 1.15;
`;

export const StudyDateTime = styled.div`
  display: flex;
  align-items: baseline;
  gap: 8px;
`;

export const StudyDate = styled.span`
  color: #f5f7fb;
  font-size: 1.1875rem;
  font-weight: 500;
`;

export const StudyTime = styled.span`
  color: #c0cce0;
  font-size: 0.9375rem;
  font-weight: 500;
`;
